<script lang="ts">
	export const IconTypes = [
		'clock',
		'downCaret',
		'rightCaret',
		'mapPin',
		'search',
		'info',
		'eye',
		'eyeHidden',
		'ticket',
		'soundcloudLogo'
	] as const;
	type IconType = (typeof IconTypes)[number];
	export let type: IconType;
</script>

{#if type === 'clock'}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class={$$props.class}
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
		/>
	</svg>
{:else if type === 'eye'}
	<svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" class={$$props.class}>
		<path
			d="M1 7.99991L0.329017 7.66482L0.161678 7.99991L0.329017 8.33499L1 7.99991ZM21 8.00002L21.671 8.3351L21.8383 8.00002L21.671 7.66493L21 8.00002ZM1.67098 8.33499C3.9893 3.69273 7.55546 1.49997 11 1.5C14.4445 1.50003 18.0107 3.69284 20.329 8.3351L21.671 7.66493C19.1618 2.64058 15.1417 3.08752e-05 11 0C6.85827 -3.08752e-05 2.83815 2.64046 0.329017 7.66482L1.67098 8.33499ZM0.329017 8.33499C2.83815 13.3593 6.85826 15.9999 11 15.9999C15.1417 16 19.1618 13.3595 21.671 8.3351L20.329 7.66493C18.0107 12.3072 14.4445 14.4999 11 14.4999C7.55547 14.4999 3.9893 12.3071 1.67098 7.66482L0.329017 8.33499ZM13.5 7.99998C13.5 9.38069 12.3807 10.5 11 10.5V12C13.2091 12 15 10.2091 15 7.99998H13.5ZM11 10.5C9.61929 10.5 8.5 9.38069 8.5 7.99998H7C7 10.2091 8.79086 12 11 12V10.5ZM8.5 7.99998C8.5 6.61927 9.61929 5.49998 11 5.49998V3.99998C8.79086 3.99998 7 5.79084 7 7.99998H8.5ZM11 5.49998C12.3807 5.49998 13.5 6.61927 13.5 7.99998H15C15 5.79084 13.2091 3.99998 11 3.99998V5.49998Z"
		/>
	</svg>
{:else if type === 'eyeHidden'}
	<svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" class={$$props.class}>
		<path
			d="M8.1654 2.42071L7.44723 2.63688L7.87955 4.07322L8.59772 3.85706L8.1654 2.42071ZM21 10L21.671 10.3351L21.8383 10L21.671 9.66493L21 10ZM18.1413 12.9666L17.646 13.5298L18.7724 14.5203L19.2677 13.9571L18.1413 12.9666ZM1 9.9999L0.329017 9.66482L0.161678 9.9999L0.329017 10.335L1 9.9999ZM16.4703 15.4703L17.0006 14.9399L16.4703 15.4703ZM19.7197 19.7803C20.0126 20.0732 20.4874 20.0732 20.7803 19.7803C21.0732 19.4874 21.0732 19.0126 20.7803 18.7197L19.7197 19.7803ZM9.23223 8.23223C9.52513 7.93934 9.52513 7.46447 9.23223 7.17157C8.93934 6.87868 8.46447 6.87868 8.17157 7.17157L9.23223 8.23223ZM13.8284 12.8284C14.1213 12.5355 14.1213 12.0607 13.8284 11.7678C13.5355 11.4749 13.0607 11.4749 12.7678 11.7678L13.8284 12.8284ZM8.59772 3.85706C12.745 2.60878 17.4769 4.624 20.329 10.3351L21.671 9.66493C18.5775 3.47055 13.1791 0.911647 8.1654 2.42071L8.59772 3.85706ZM19.2677 13.9571C20.1654 12.9364 20.9755 11.7277 21.671 10.3351L20.329 9.66493C19.6865 10.9515 18.9468 12.0507 18.1413 12.9666L19.2677 13.9571ZM1.21967 1.28033L4.99937 5.06003L6.06003 3.99937L2.28033 0.21967L1.21967 1.28033ZM1.67098 10.335C2.84083 7.99245 4.33197 6.27257 5.95699 5.14609L5.10242 3.91332C3.24158 5.20327 1.5948 7.13019 0.329017 9.66482L1.67098 10.335ZM4.99937 5.06003L15.9399 16.0006L17.0006 14.9399L6.06003 3.99937L4.99937 5.06003ZM15.9399 16.0006L19.7197 19.7803L20.7803 18.7197L17.0006 14.9399L15.9399 16.0006ZM0.329017 10.335C2.20469 14.0909 4.92036 16.5148 7.91701 17.5009C10.922 18.4898 14.1308 18.0045 16.8975 16.0866L16.043 14.8539C13.6436 16.5171 10.9221 16.9107 8.38589 16.0761C5.84135 15.2388 3.40494 13.1369 1.67098 9.66482L0.329017 10.335ZM11 12.5C9.61929 12.5 8.5 11.3807 8.5 10H7C7 12.2091 8.79086 14 11 14V12.5ZM8.5 10C8.5 9.30944 8.779 8.68547 9.23223 8.23223L8.17157 7.17157C7.44854 7.89461 7 8.89564 7 10H8.5ZM12.7678 11.7678C12.3145 12.221 11.6906 12.5 11 12.5V14C12.1044 14 13.1054 13.5515 13.8284 12.8284L12.7678 11.7678ZM1.21967 1.28033L19.7197 19.7803L20.7803 18.7197L2.28033 0.21967L1.21967 1.28033Z"
		/>
	</svg>
{:else if type === 'info'}
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class={$$props.class}>
		<path
			d="M7.16671 7.3335H8.00004L8.00004 10.8335M14.1667 8.00016C14.1667 11.4059 11.4058 14.1668 8.00004 14.1668C4.59428 14.1668 1.83337 11.4059 1.83337 8.00016C1.83337 4.59441 4.59428 1.8335 8.00004 1.8335C11.4058 1.8335 14.1667 4.59441 14.1667 8.00016Z"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.99996 4.875C7.74683 4.875 7.54163 5.0802 7.54163 5.33333C7.54163 5.58646 7.74683 5.79167 7.99996 5.79167C8.25309 5.79167 8.45829 5.58646 8.45829 5.33333C8.45829 5.0802 8.25309 4.875 7.99996 4.875Z"
			stroke-width="0.25"
		/>
	</svg>
{:else if type === 'soundcloudLogo'}
	<svg viewBox="0 0 27 14" fill="none" xmlns="http://www.w3.org/2000/svg" class={$$props.class}>
		<path
			d="M11.745 2.02253C11.5818 2.02253 11.4488 2.15552 11.4488 2.31873C11.201 5.64335 11.0015 8.75641 11.4488 12.0689C11.4488 12.2322 11.5818 12.3651 11.745 12.3651C11.9082 12.3651 12.0412 12.2322 12.0412 12.0689C12.5188 8.72619 12.3193 5.66753 12.0412 2.31873C12.0412 2.15552 11.9082 2.02253 11.745 2.02253Z"
			fill="white"
		/>
		<path
			d="M9.87719 3.16513C9.70794 3.16513 9.56286 3.30416 9.56286 3.47946C9.27271 6.4414 9.18808 9.13132 9.56286 12.0872C9.58704 12.2444 9.71398 12.3592 9.87114 12.3592C10.0283 12.3592 10.1613 12.2444 10.1794 12.0872C10.6026 9.08296 10.5058 6.46558 10.1855 3.47946C10.1855 3.30416 10.0464 3.16513 9.87719 3.16513Z"
			fill="white"
		/>
		<path
			d="M8.02144 2.88692C7.85824 2.88692 7.72525 3.0199 7.72525 3.18311C7.4351 6.21154 7.29607 9.04654 7.72525 12.075C7.72525 12.2382 7.85824 12.3712 8.02144 12.3712C8.18465 12.3712 8.31764 12.2382 8.31764 12.075C8.75891 9.00423 8.61988 6.25386 8.31764 3.18311C8.32368 3.0199 8.18465 2.88692 8.02144 2.88692Z"
			fill="white"
		/>
		<path
			d="M23.2845 4.99669C22.952 4.99669 22.6256 5.039 22.3113 5.12967C21.9486 3.45527 20.9029 2.01057 19.4279 1.14616C18.4849 0.590044 17.409 0.293851 16.3209 0.299895C14.5438 0.299895 13.6975 0.880194 13.6975 0.880194C13.3771 1.01922 13.1716 1.34564 13.1897 1.69624V11.5794C13.1897 12.0026 13.5282 12.3411 13.9514 12.3471H23.1394C25.1463 12.3471 26.8993 10.8057 26.9597 8.78071C26.9899 7.78937 26.6152 6.82825 25.9261 6.11497C25.2249 5.39564 24.2758 4.99669 23.2845 4.99669Z"
			fill="white"
		/>
		<path
			d="M6.15965 3.74549C5.9904 3.74549 5.85137 3.88452 5.85137 4.05378C5.50682 6.71952 5.50682 9.42154 5.85137 12.0933C5.8695 12.2505 5.99644 12.3714 6.15361 12.3714C6.31077 12.3714 6.44376 12.2505 6.45585 12.0933C6.82458 9.42758 6.83062 6.72557 6.46189 4.05378C6.47398 3.87848 6.33495 3.74549 6.15965 3.74549Z"
			fill="white"
		/>
		<path
			d="M2.42398 5.46218C2.26682 5.46218 2.12779 5.57703 2.10965 5.73419C1.72883 7.83777 1.84973 9.70561 2.12174 11.8213C2.15197 12.1417 2.696 12.1356 2.72622 11.8213C3.02846 9.68143 3.17353 7.868 2.73831 5.73419C2.71413 5.57703 2.58115 5.46218 2.42398 5.46218Z"
			fill="white"
		/>
		<path
			d="M0.550103 6.47159C0.386894 6.47159 0.247864 6.59853 0.235774 6.76174C-0.139001 8.17622 -0.0120612 9.361 0.259954 10.7815C0.259954 10.9387 0.386894 11.0717 0.550103 11.0717C0.713312 11.0717 0.840252 10.9447 0.840252 10.7815C1.16062 9.34286 1.31779 8.18831 0.870476 6.76174C0.846297 6.59853 0.713312 6.47159 0.550103 6.47159Z"
			fill="white"
		/>
		<path
			d="M4.29182 5.76433C4.13465 5.76433 4.00167 5.88522 3.98958 6.04239C3.54226 8.1097 3.75383 10.0138 3.98958 12.1053C3.98958 12.2625 4.11652 12.3954 4.27973 12.3954C4.44294 12.3954 4.56988 12.2685 4.56988 12.1053C4.85398 9.97754 5.07159 8.13992 4.59405 6.04239C4.58196 5.88522 4.44898 5.76433 4.29182 5.76433Z"
			fill="white"
		/>
	</svg>
{:else if type === 'search'}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="3"
		stroke="currentColor"
		class={$$props.class}
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
		/>
	</svg>
{:else if type === 'downCaret'}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class={$$props.class}
	>
		<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
	</svg>
{:else if type === 'rightCaret'}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class={$$props.class}
	>
		<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
	</svg>
{:else if type === 'mapPin'}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class={$$props.class}
	>
		<path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
		/>
	</svg>
{:else if type === 'ticket'}
	<svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" class={$$props.class}>
		<path
			d="M13.25 3.75V4.25M13.25 7.75V8.25M13.25 11.75V12.25M2.75 0.75H17.25C18.3546 0.75 19.25 1.64543 19.25 2.75V5.25C16.5 6 16.5 10 19.25 10.75V13.25C19.25 14.3546 18.3546 15.25 17.25 15.25H2.75C1.64543 15.25 0.75 14.3546 0.75 13.25V10.75C3.5 10 3.5 6 0.75 5.25V2.75C0.75 1.64543 1.64543 0.75 2.75 0.75Z"
			stroke="#959595"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
{/if}
